module.exports = __webpack_public_path__ + "static/media/ic_player_plus_15.7e61e2f1.svg";